export enum UserExtensionQuality {
    UNAVAILABLE = 'UNAVAILABLE',
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
}
